import React, {useState} from 'react'
import PropTypes from 'prop-types'

import {StyledBar, StyledBarContainer, StyledSlider, TextKey, TextKeys, ValueKey,} from './KeyFigures.styled'
import openUrl from '../../utils/OpenUrl'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import useMediaQuery from "../../hooks/useMediaQuery";
import {deviceMax} from "../../theme/breakpoints";

const ARROWS = false
const SLIDES_TO_SHOW = 1.5
const DRAGGABLE = true
const SLIDES_PER_ROW = 1
const INFINITE = false

const KeyFigures = (props) => {
  const {keyFiguresBanner, isCentered = false} = props
  const [sliderRef, setSliderRef] = useState(null)

  const isMobile = useMediaQuery(deviceMax.mobileL)

  const sliderSettings = {
    arrows: ARROWS,
    draggable: DRAGGABLE,
    slidesToShow: isMobile ? 1.5 : 2.5,
    slidesPerRow: SLIDES_PER_ROW,
    infinite: INFINITE,
  }

  const goToPage = (keyFigure) => {
    if (keyFigure.url !== null) {
      openUrl(keyFigure.url)
    } else if (keyFigure.document !== null && keyFigure.document.url !== null) {
      openUrl(keyFigure.document.url)
    } else if (
      keyFigure.document !== null &&
      keyFigure.document.cloudinary[0].original_url !== null
    ) {
      openUrl(keyFigure.document.cloudinary[0].original_url)
    }
  }

  const keys = keyFiguresBanner
    ? keyFiguresBanner?.map((key, index) => {
      const canHover =
        key.url !== null ||
        (key.document !== null &&
          (key.document.url !== null ||
            (key.document.cloudinary !== null &&
              key.document.cloudinary[0].original_url !== null)))

      return (
        <TextKeys
          key={index + 'texts'}
          onClick={() => goToPage(key)}
          $hovered={canHover}
        >
          <ValueKey key={index + 'value'}>{key.keyFigure}</ValueKey>
          {key.text && (
            <TextKey key={index + 'text'}>{key.text.text}</TextKey>
          )}
        </TextKeys>
      )
    })
    : null
  return (
    <StyledBar $centered={isCentered}>
      {isMobile ? (
        <StyledSlider ref={setSliderRef} {...sliderSettings}>
          {keys}
        </StyledSlider>
      ) : (
        <StyledBarContainer $centered={isCentered}>{keys}</StyledBarContainer>
      )}
    </StyledBar>
  )
}

KeyFigures.propTypes = {
  keyFiguresBanner: PropTypes.array.isRequired,
}

export default KeyFigures
